import * as actionTypes from "./actionTypes";
import { request } from "helper/http-client";
import { url } from "config.js";
import { notify } from "helper/global";

export const _loadUser = (result) => {
  return {
    type: actionTypes.USER_LOAD,
    ...result,
  };
};

function _upateUser(data) {
  return {
    type: actionTypes.USER_UPDATE,
    ...data,
  };
}

export const loadUser = () => {
  return async (dispatch) => {
    try {
      let result = await request({ url: `${url}/user/setting` });
      dispatch(_loadUser(result));
    } catch (error) {
      throw Error("Unable to load user settings");
    }
    return "done";
  };
};

export function saveUser(data) {
  return async (dispatch) => {
    try {
      await request({ url: `${url}/user/setting`, method: "Put", data: data });
      dispatch(_upateUser(data));
    } catch (error) {
      notify("Unable to save user settings", "error");
    }
  };
}
